export default {"src":"/_next/static/media/Find Energy logo.50930eee.svg","height":37,"width":216,"blurWidth":0,"blurHeight":0};